import React, { useState, useEffect } from 'react';
import styles from './nav-bar.module.scss';
import { Icon } from '../../interfaces';
import { Link } from '@reach/router';
import { useStateValue } from '../state';
import { ReactComponent as Drop } from '../../svg/drop.svg';
import { ReactComponent as Drops } from '../../svg/drops.svg';
import { ReactComponent as Tap } from '../../svg/tap.svg';
import { ReactComponent as Recycle } from '../../svg/recycle.svg';

export const NavBar: React.FC = ({ children }) => {
  return (
    <nav className={styles.navbar}>
      {React.Children.map(children, (child: any) => {
        if (child && child.type === NavBarItem) {
          return child;
        } else {
          return null;
        }
      })}
    </nav>
  );
};

interface NavBarProps {
  title: string;
  link: string;
  active?: boolean;
  icon?: Icon;
}

export const NavBarItem: React.FC<NavBarProps> = ({ link, icon, title, active, ...props }) => {
  const [isActive, setIsActive] = useState(active || false);
  const activeClass = isActive ? styles.active : '';
  const [, dispatch] = useStateValue();

  // Open up the side panel if any of the nav bar items are active
  useEffect(() => {
    if (isActive) {
      dispatch({ type: 'openSidePanel' });
    }
  }, [dispatch, isActive]);

  const checkIsActive: any = ({ isPartiallyCurrent }: any) => {
    setIsActive(isPartiallyCurrent);
  };

  let Icon;

  switch (icon) {
    case 'drop':
      Icon = Drop;
      break;
    case 'drops':
      Icon = Drops;
      break;
    case 'recycle':
      Icon = Recycle;
      break;
    case 'tap':
      Icon = Tap;
      break;
    default:
      Icon = Drop;
      break;
  }

  return (
    <Link to={link} className={`${styles.navitem} ${activeClass}`} getProps={checkIsActive}>
      <span>
        {icon && <Icon className={styles.icon} role="img" />}
        {title}
      </span>
    </Link>
  );
};
